module.exports = __webpack_public_path__ + "img/icon02.19e99168.png";